import * as React from 'react';
import { ComponentProps, ToggleButton, ToggleButtonProps } from 'ui';
import { MdOutlineReplay } from 'react-icons/md';
import { EgressPanelIcon } from 'app/area/case/components/icons/egress-panel-icon';
import { resolveEgressRecordedBy } from './resolve-egress-recorded-by';

interface EgressToggleButtonProps extends ComponentProps, ToggleButtonProps {
  currentUser?: { value: string | number; description?: string };
  entryLogValues?: { egressTimeRecordedBy?: { value: string | number; description?: string } };
  rowEntity?: any;
  showLabelTextWithIcon?: boolean;
  textLabelPrefix?: string;
}

export const EgressToggleButton: React.FC<EgressToggleButtonProps> = props => {
  const recordedBy = resolveEgressRecordedBy(props.rowEntity, props.currentUser, props.entryLogValues);
  const recordedByText = recordedBy ? `${props.textLabelPrefix} ${recordedBy}` : undefined;

  return (
    <ToggleButton
      {...props}
      buttonIcon={props.showLabelTextWithIcon ? <EgressPanelIcon /> : undefined}
      buttonIconToggle={props.showLabelTextWithIcon ? <MdOutlineReplay /> : undefined}
      secondaryValueText={recordedByText}
      bgColorOverride = {true}
    />
  );
};
